/** Copy for the Deliver composer, deliveries list and confirm dialogs. */
export const DELIVER_COPY = {
  title: "Deliver story",
  subtitle: "Send your story to your team across channels",
  cancel: "Cancel",
  previewLabel: "Preview",
  previewNoImage: "No preview image for this attachment",
  previewSummaryTitle: "AI executive summary",
  /** Attachment type shown under the preview, derived from the chosen format. */
  previewFormatName: {
    presentation: "PowerPoint (.pptx)",
    pdf: "PDF (.pdf)",
    video: "Video",
    "image-set": "Image set",
  },
  /** Neutral default message built from the story; the summary is optional. */
  defaultMessage: (title?: string, summary?: string): string => {
    const name = title?.trim();
    const lead = name ? `Here is the latest on ${name}.` : "Here is the latest update on this story.";
    const first = summary?.trim().split(/(?<=[.!?])\s/)[0];
    return [lead, first, "Open the full story for the details."].filter(Boolean).join(" ");
  },
  sendTo: "Send to",
  destination: "Channels and people",
  whenLabel: "When",
  whenSendNow: "Send now",
  whenSchedule: "On a schedule",
  whenKpi: "When a KPI changes",
  whatToSend: "What to send",
  format: "Format",
  theme: "Theme",
  themeNotApplicable: "Applies to a Presentation sent as PDF or PowerPoint",
  message: "Message",
  messagePlaceholder: "Add a message for your team",
  includeAttachment: "Include attachment",
  startsOn: "Starts on",
  refreshNote: "Data refreshes before each send.",
  nextSendPrefix: "Next send:",
  sendTest: "Send a test",
  submitSendNow: "Send now",
  submitSchedule: "Schedule",
  submitAlert: "Create alert",
  sending: "Sending…",
  activeDeliveries: "Active deliveries",
  settingsLoading: "Magic is still reading your organization's settings. Try again in a moment.",
  deliverFailed: "Couldn't deliver the Story.",
  addNew: "Add new delivery",
  /** Share menu status line for Personalized distribution while none is set up. */
  shareStatusNone: "None set up yet",
  confirm: {
    cancel: {
      title: "Cancel this delivery?",
      description:
        "It will stop sending. This can't be undone — you'd need to create a new delivery to resume.",
      confirmLabel: "Cancel delivery",
    },
    delete: {
      title: "Delete this delivery?",
      description: "This permanently removes the delivery and its history. This can't be undone.",
      confirmLabel: "Delete",
    },
  },
} as const;
